//grabbing hostname 
export default {
    baseUrl: `${window.location.protocol}//${window.location.hostname}`
  };